import { render, staticRenderFns } from "./YamaPage.vue?vue&type=template&id=b4758404&scoped=true&"
import script from "./YamaPage.vue?vue&type=script&lang=js&"
export * from "./YamaPage.vue?vue&type=script&lang=js&"
import style0 from "./YamaPage.vue?vue&type=style&index=0&id=b4758404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4758404",
  null
  
)

export default component.exports